const inflight = {};

export function fetchOnce(key, fetchFn) {
	if (!inflight[key]) {
		inflight[key] = fetchFn().finally(() => {
			delete inflight[key];
		});
	}
	return inflight[key];
}
